<template>
  <main class="contact-page">
    <section class="contact-hero">
      <div class="container">
        <div class="contact-hero-grid">
          <div class="contact-hero-copy">
            <span class="contact-eyebrow">Ankara Ağrılılar Derneği iletişim</span>
            <h1>Ankara'daki Ağrılılara ulaşmanın en kolay yolu</h1>
            <p>
              Derneğe katılmak, WhatsApp grubuna yönlendirilmek, konum almak veya Ankara'daki Ağrılılar
              dayanışma ağına dahil olmak için bize tek dokunuşla ulaşabilirsiniz.
            </p>
            <div class="contact-hero-actions">
              <a href="tel:+905079217404" class="btn btn-primary">
                <i class="fa fa-phone-alt"></i>
                Dernek hattını ara
              </a>
              <a :href="whatsappJoinUrl" target="_blank" rel="noopener" class="btn btn-light">
                <i class="fab fa-whatsapp"></i>
                WhatsApp'a yaz
              </a>
            </div>
          </div>
          <aside class="contact-call-card">
            <span>Dernek hattı</span>
            <a href="tel:+905079217404">+90 507 921 74 04</a>
            <small>Üyelik, gönüllülük, etkinlik, taziye, firma tanıtımı ve sosyal destek talepleri için arayabilirsiniz.</small>
          </aside>
        </div>
      </div>
    </section>

    <section class="contact-main">
      <div class="container">
        <div class="contact-action-grid">
          <a href="tel:+905079217404" class="contact-action-card">
            <i class="fa fa-phone-alt"></i>
            <span>Telefon</span>
            <strong>Hemen ara</strong>
            <small>+90 507 921 74 04</small>
          </a>
          <a :href="whatsappJoinUrl" target="_blank" rel="noopener" class="contact-action-card">
            <i class="fab fa-whatsapp"></i>
            <span>WhatsApp</span>
            <strong>Gruba katıl</strong>
            <small>Hazır mesajla başvur</small>
          </a>
          <a :href="mapsUrl" target="_blank" rel="noopener" class="contact-action-card">
            <i class="fa fa-map-marker-alt"></i>
            <span>Konum</span>
            <strong>Haritada aç</strong>
            <small>Sincan / Ankara</small>
          </a>
          <a href="https://www.instagram.com/ankara_agrililar_dernegi/" target="_blank" rel="noopener" class="contact-action-card">
            <i class="fab fa-instagram"></i>
            <span>Sosyal medya</span>
            <strong>Instagram</strong>
            <small>Güncel duyurular</small>
          </a>
        </div>

        <div class="contact-content-grid">
          <section class="contact-info-panel">
            <div class="contact-section-title">
              <h2>Dernek bilgileri</h2>
              <p>Resmi bilgiler ve sahada kullanılan iletişim kanalları.</p>
            </div>
            <dl class="contact-details">
              <div>
                <dt>Bilinen ad</dt>
                <dd>Ankara Ağrılılar Derneği</dd>
              </div>
              <div>
                <dt>Resmi ad</dt>
                <dd>Başkent Ağrılılar Eğitim Kültür Sosyal Yardımlaşma ve Dayanışma Derneği</dd>
              </div>
              <div>
                <dt>Kütük no</dt>
                <dd>06-158-130</dd>
              </div>
              <div>
                <dt>Adres</dt>
                <dd>Dernek Binası, Mustafa Kemal, Ziya Gökalp Cd., 06946 Sincan/Ankara</dd>
              </div>
              <div>
                <dt>Telefon</dt>
                <dd><a href="tel:+905079217404">+90 507 921 74 04</a></dd>
              </div>
            </dl>
          </section>

          <aside class="contact-community-panel">
            <h2>Ankara'da yaşayan Ağrılılar için</h2>
            <p>
              Mamak, Keçiören, Sincan, Etimesgut, Yenimahalle, Altındağ, Pursaklar ve Çankaya'da yaşayan
              Ağrılı hemşehrilerimizi aynı dayanışma çatısında buluşturuyoruz.
            </p>
            <div class="contact-tags">
              <span v-for="tag in seoTags" :key="tag">{{ tag }}</span>
            </div>
            <a :href="mapsUrl" target="_blank" rel="noopener" class="contact-map-link">
              <i class="fa fa-location-arrow"></i>
              Konumu Google Haritalar'da aç
            </a>
          </aside>
        </div>

        <section class="contact-social-strip">
          <div>
            <h2>Duyuruları kaçırmayın</h2>
            <p>Toplantı, piknik, taziye, sosyal destek ve Ağrı ilçe buluşmaları için sosyal medya hesaplarımızı takip edebilirsiniz.</p>
          </div>
          <div class="contact-social-actions">
            <a href="https://www.facebook.com/baskentagrililardernegi" target="_blank" rel="noopener">
              <i class="fab fa-facebook-f"></i>
              Facebook
            </a>
            <a href="https://www.instagram.com/ankara_agrililar_dernegi/" target="_blank" rel="noopener">
              <i class="fab fa-instagram"></i>
              Instagram
            </a>
          </div>
        </section>
      </div>
    </section>
  </main>
</template>

<script setup>
const mapsUrl = 'https://www.google.com/maps/place//data=!4m2!3m1!1s0x14d32f0045182ff9:0x7675f5df2b90b8b?sa=X&ved=1t:8290&ictx=111';
const whatsappJoinUrl = `https://wa.me/905079217404?text=${encodeURIComponent('Derneğinize websitesinden katıldım, herkese merhabalar.')}`;

const seoTags = [
  'Ankara Ağrılılar',
  'Doğubayazıtlılar',
  'Patnoslular',
  'Mamak Ağrılılar',
  'Keçiören Ağrılılar',
  'Sincan Ağrılılar',
  'Etimesgut Ağrılılar',
  'Ağrı hemşehri ağı'
];
</script>

<style scoped>
.contact-page {
  background: #FFFFFF;
}

.contact-hero {
  position: relative;
  overflow: hidden;
  background:
    radial-gradient(circle at 12% 18%, rgba(254, 161, 22, .22), transparent 28%),
    linear-gradient(135deg, #0F172B 0%, #172443 54%, #0F172B 100%);
  color: #FFFFFF;
}

.contact-hero::before,
.contact-hero::after {
  content: "";
  position: absolute;
  inset: auto -8% 34px auto;
  width: 46%;
  height: 18px;
  background: var(--primary);
  transform: rotate(-8deg);
  opacity: .9;
}

.contact-hero::after {
  inset: 72px auto auto -10%;
  width: 40%;
  height: 10px;
  background: #FFFFFF;
  opacity: .18;
}

.contact-hero-grid {
  position: relative;
  z-index: 1;
  display: grid;
  grid-template-columns: minmax(0, 1fr) 360px;
  gap: 34px;
  align-items: end;
  min-height: 460px;
  padding: 76px 0;
}

.contact-eyebrow {
  display: inline-flex;
  color: var(--primary);
  font-weight: 900;
  text-transform: uppercase;
  letter-spacing: 0;
  margin-bottom: 16px;
}

.contact-hero h1 {
  max-width: 820px;
  margin: 0 0 18px;
  color: #FFFFFF;
  font-size: clamp(36px, 5vw, 66px);
  line-height: 1.04;
}

.contact-hero p {
  max-width: 760px;
  color: rgba(255, 255, 255, .82);
  font-size: 19px;
  line-height: 1.8;
  margin: 0;
}

.contact-hero-actions,
.contact-social-actions {
  display: flex;
  flex-wrap: wrap;
  gap: 12px;
  margin-top: 26px;
}

.contact-hero-actions .btn {
  min-height: 52px;
  display: inline-flex;
  align-items: center;
  gap: 10px;
  border-radius: 6px;
  font-weight: 800;
  padding: 14px 20px;
}

.contact-call-card {
  background: #FFFFFF;
  color: var(--dark);
  border-radius: 8px;
  padding: 28px;
  box-shadow: 0 24px 60px rgba(0, 0, 0, .24);
}

.contact-call-card span {
  color: var(--primary);
  font-weight: 900;
  text-transform: uppercase;
}

.contact-call-card a {
  display: block;
  color: var(--dark);
  font-size: 30px;
  font-weight: 900;
  line-height: 1.15;
  margin: 12px 0;
}

.contact-call-card small {
  display: block;
  color: #5B6475;
  line-height: 1.65;
}

.contact-main {
  padding: 44px 0 70px;
  background: linear-gradient(180deg, #F8FAFD 0%, #FFFFFF 42%);
}

.contact-action-grid {
  display: grid;
  grid-template-columns: repeat(4, minmax(0, 1fr));
  gap: 18px;
  margin-bottom: 28px;
}

.contact-action-card,
.contact-info-panel,
.contact-community-panel,
.contact-social-strip {
  background: #FFFFFF;
  border: 1px solid rgba(15, 23, 43, .08);
  border-radius: 8px;
  box-shadow: 0 14px 36px rgba(15, 23, 43, .07);
}

.contact-action-card {
  display: grid;
  gap: 7px;
  min-height: 170px;
  padding: 22px;
  color: var(--dark);
  transition: transform .2s ease, box-shadow .2s ease, border-color .2s ease;
}

.contact-action-card:hover {
  transform: translateY(-4px);
  border-color: rgba(254, 161, 22, .45);
  box-shadow: 0 20px 46px rgba(15, 23, 43, .12);
}

.contact-action-card i {
  color: var(--primary);
  font-size: 30px;
}

.contact-action-card span,
.contact-details dt {
  color: #667085;
  font-weight: 800;
  text-transform: uppercase;
  font-size: 12px;
}

.contact-action-card strong {
  font-size: 22px;
  line-height: 1.2;
}

.contact-action-card small {
  color: #667085;
  line-height: 1.45;
}

.contact-content-grid {
  display: grid;
  grid-template-columns: minmax(0, 1.35fr) minmax(320px, .65fr);
  gap: 24px;
}

.contact-info-panel,
.contact-community-panel {
  padding: 30px;
}

.contact-section-title h2,
.contact-community-panel h2,
.contact-social-strip h2 {
  color: var(--dark);
  font-size: 28px;
  margin: 0 0 10px;
}

.contact-section-title p,
.contact-community-panel p,
.contact-social-strip p {
  color: #5B6475;
  line-height: 1.75;
  margin: 0;
}

.contact-details {
  display: grid;
  gap: 14px;
  margin: 24px 0 0;
}

.contact-details div {
  display: grid;
  grid-template-columns: 140px minmax(0, 1fr);
  gap: 18px;
  align-items: start;
  padding: 16px 0;
  border-top: 1px solid rgba(15, 23, 43, .08);
}

.contact-details dd {
  color: var(--dark);
  font-weight: 800;
  margin: 0;
}

.contact-details a {
  color: var(--primary);
}

.contact-community-panel {
  background: var(--dark);
  color: #FFFFFF;
}

.contact-community-panel h2 {
  color: #FFFFFF;
}

.contact-community-panel p {
  color: rgba(255, 255, 255, .74);
}

.contact-tags {
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
  margin: 22px 0;
}

.contact-tags span {
  background: rgba(255, 255, 255, .08);
  border: 1px solid rgba(255, 255, 255, .12);
  border-radius: 999px;
  color: #FFFFFF;
  font-weight: 800;
  padding: 8px 11px;
  font-size: 13px;
}

.contact-map-link {
  display: inline-flex;
  align-items: center;
  gap: 10px;
  color: var(--primary);
  font-weight: 900;
}

.contact-social-strip {
  display: flex;
  justify-content: space-between;
  gap: 24px;
  align-items: center;
  margin-top: 24px;
  padding: 28px 30px;
}

.contact-social-actions {
  margin-top: 0;
}

.contact-social-actions a {
  display: inline-flex;
  align-items: center;
  gap: 9px;
  min-height: 46px;
  padding: 12px 16px;
  border-radius: 6px;
  background: #F5F7FB;
  color: var(--dark);
  font-weight: 900;
}

.contact-social-actions a:hover {
  background: var(--primary);
  color: #FFFFFF;
}

@media (max-width: 991.98px) {
  .contact-hero-grid,
  .contact-content-grid {
    grid-template-columns: 1fr;
  }

  .contact-hero-grid {
    min-height: auto;
    padding: 56px 0;
  }

  .contact-action-grid {
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }

  .contact-social-strip {
    align-items: flex-start;
    flex-direction: column;
  }
}

@media (max-width: 575.98px) {
  .contact-hero-grid {
    padding: 42px 0;
  }

  .contact-hero h1 {
    font-size: 36px;
  }

  .contact-hero p {
    font-size: 16px;
  }

  .contact-hero-actions .btn,
  .contact-social-actions a {
    width: 100%;
    justify-content: center;
  }

  .contact-call-card,
  .contact-info-panel,
  .contact-community-panel,
  .contact-social-strip {
    padding: 22px;
  }

  .contact-call-card a {
    font-size: 26px;
  }

  .contact-action-grid {
    grid-template-columns: 1fr;
    gap: 12px;
  }

  .contact-action-card {
    min-height: 132px;
  }

  .contact-details div {
    grid-template-columns: 1fr;
    gap: 7px;
  }
}
</style>
